import { DateTime } from 'luxon';
export function getDateFromDatetime(datetime) {
  if (!datetime) {
    return '';
  }
  const date = datetime.split('T')[0];
  return date;
}
export function formatDate(srDate) {
  return DateTime.fromISO(srDate).toLocaleString({
    month: 'long',
    day: '2-digit',
    year: 'numeric'
  });
}
export function createDateWithOffset(baseDate, daysOffset) {
  const date = new Date(baseDate);
  date.setDate(baseDate.getDate() + daysOffset);
  return date;
}
export function formatMiddleEndianDate(date) {
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'UTC'
  });
}